export default "__VITE_ASSET__9RsdpW8A__"